import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import StatusCheckModal from "./component/StatusCheckModel";
import NewPanApplicationForm from "./component/newPanApplication";
import IncompleteFormModal from "./component/IncompleteFormModal";
import ErrorPage from "./component/ErrorPage";
// import FullscreenModal from "./components/FullScreenModal";
// import { RegisterKYCModalBody, RegisterKYCModalFooter } from "./components/RegisterBankKYCModalComponent";

function PancardServices() {
  const { name, userid, role } = useSession();
  const [data, setData] = useState(null); // to store API data
  const [loading, setLoading] = useState(true); // to manage loader
  const [error, setError] = useState(null); // to handle errors
  const navigate = useNavigate()
  const [modalShow, setModalShow] = useState(false);
  const [newmodalShow, setnewModalShow] = useState(false);
  const [incmodalShow, setincModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [refresh, setRefresh] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [errorHtml, setErrorHtml] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchWrapper(
          `https://pro.mokshiq.in/get_user_profile?user=${userid}`
        );

        setData(response.data);
      } catch (err) {
        showMainToast(err.message, 'danger');
      } finally {
        setLoading(false); // hide loader
      }
    };
    setRefresh(refresh + 1)
    fetchData();
  }, []);

  const handleStatusCheck = () => {
    setModalMode("add");

    setModalShow(true);
  };
  const handleNewApplication = () => {
    setModalMode("add");

    setnewModalShow(true);
  };
  const handleIncompleteApplication = () => {
    setModalMode("add");

    setincModalShow(true);
  };


  const onboardingPS = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      // formData.append("userid", "3");
      const response = await fetchWrapper(
        `https://pro.mokshiq.in/nsdl_onboarding_sf?userid=${userid}`
      );


      if (response.status) {
        showMainToast(response.data, "success");
      }

      else {
        showMainToast(response.data, "danger");
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }


  }

  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setModalShow(false)
  };
  const handleFormSuccess2 = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setincModalShow(false)
  };
  const handleFormSuccess1 = (html) => {

    setErrorHtml(html);
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setnewModalShow(false)
  };

  return (
    <main>
      <div className="container-fluid ui-section">
        <div className="row m-1">
          <div className="col-12 ">
            <h4 className="main-title">Pancard Service</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  Pancard
                </a>
              </li>
            </ul>
          </div>
        </div>

        {loading ? (
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="loader-container">
                    <div className="loader-main">
                      <div className="loader_box">
                        <div className="loader_16"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {/* ✅ Three condition cases */}
            {data?.nsdl_id !== "" ? (
              <div className="col-md-12">
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-xl-4">
                    <div className="card">
                      <div className="card-header">
                        <h5>New/Correction Pancard</h5>
                        <p className="mb-0 text-secondary">
                          Apply for a New/Correction Pancard ✅
                        </p>
                      </div>
                      <div className="card-body">
                        <button className="btn btn-primary btn-md" type="button" onClick={handleNewApplication}>
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-4">
                    <div className="card">
                      <div className="card-header">
                        <h5>Incomlete Pancard</h5>
                        <p className="mb-0 text-secondary">
                          For incmplete application of Pancard
                        </p>
                      </div>
                      <div className="card-body">
                        <button className="btn btn-primary btn-md" type="button" onClick={handleIncompleteApplication}>
                          Initiate Again
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-4">
                    <div className="card">
                      <div className="card-header">
                        <h5>Check Status</h5>
                        <p className="mb-0 text-secondary">
                          Check Status  of Your Pancard
                        </p>
                      </div>
                      <div className="card-body">
                        <button className="btn btn-primary btn-md" type="button" onClick={handleStatusCheck}>
                          Check Status
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            ) : (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick Pancard</h5>
                    <p className="mb-0 text-secondary">
                      Submit KYC – Aadhaar, PAN, and Bank details.
                    </p>
                  </div>
                  <div className="card-body">
                    <button
                      className="btn btn-light-primary btn-md"
                      type="button" onClick={onboardingPS}
                    >
                      Start Onboarding
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* {errorHtml && <ErrorPage htmlString={errorHtml} />} */}
          </div>
        )}
      </div>
      <StatusCheckModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess}
      />
      <IncompleteFormModal
        show={incmodalShow}
        onClose={() => setincModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess2}
      />
      <NewPanApplicationForm
        show={newmodalShow}
        onClose={() => setnewModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess1}
      />
      {/* <FullscreenModal
      id="modalAlwaysFullscreen"
      title="Register Bank KYC"
      body={RegisterKYCModalBody}
      footer={RegisterKYCModalFooter}
      fullscreen={false} 
      /> */}
    </main>
  );

}

export default PancardServices;
